<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="download" />
    <div class="features-section  features-bgList">
      <h1>Select Your Device to Download GB WhatsApp</h1>
      <div>
        <a href="https://gbmodshub.com/" class="jump-url">GB WhatsApp</a> is designed primarily for Android devices, but it can also be used on other platforms with the help
        of third-party tools. Whether you're looking to install GB WhatsApp on a smartphone, use it on a PC or Mac, or
        access it through the web, there are options available for each.
      </div>
      <div>
        <img src="@/assets/download-icon.webp" alt="GB WhatsApp for andriod" style="width:80px;height:80px;"/>
      </div>
      <div>
        <button class="free-download-btn4" @click="goDownload()"> GB WhatsApp Download for Android Phone </button>
      </div>
      <div>
        <button class="free-download-btn4" @click="goJump('/download/gb-whatsapp-pc/')">GB WhatsApp Download for PC & Mac</button>
      </div>
      <div>
        <button class="free-download-btn4" @click="goJump('/download/gb-whatsapp-web/')">GB WhatsApp Download for Web</button>
      </div>
      <div class="figure-table" style="padding-bottom: 0;">
        <figure class="wp-block-table">
          <table>
            <thead>
              <tr>
                <th>App Name</th>
                <th>GB WhatsApp APK</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Android Version</td>
                <td>5.0 and Above</td>
              </tr>
              <tr>
                <td>Version</td>
                <td>V18.70</td>
              </tr>
              <tr>
                <td>Total Downloads</td>
                <td>100M+</td>
              </tr>
              <tr>
                <td>App Size</td>
                <td>75.8MB</td>
              </tr>
              <tr>
                <td>Root Required</td>
                <td>No Root Required</td>
              </tr>
              <tr>
                <td>Main Purpose</td>
                <td>WhatsApp Extra Features</td>
              </tr>
              <tr>
                <td>Last Updated</td>
                <td>Last Updated</td>
              </tr>
            </tbody>
          </table>
        </figure>
      </div>
      <!-- <div>
        <button class="free-download-btn" @clack="goDownload()">GB WhatsApp Download Latest version</button>
      </div> -->
      <div>
        <h2  class="intro-title" style="border-top:none;border-bottom:none;">Pick your device and download GB WhatsApp today!</h2>
        <div class="advanced-list">
          <div v-for="item in itemsList" :key="item.key" class="advanced-item" @click="goJump(item.link)">
            <img :src="item.img" alt="GB WhatsApp for andriod">
            <div>
              <h3>{{ item.text }}</h3>
            </div>
          </div>
        </div>
        <div>
          <h2 class="intro-title" style="border-top:none;border-bottom:none;">Quick overview of supported devices:</h2>
          <ul class="quick-overview">
            <li> <strong>Android Phones</strong>: Fully supported. Download and install the GB WhatsApp APK directly.
            </li>
            <li> <strong>PC / Mac</strong>: Use GB WhatsApp via Android emulators like BlueStacks or NoxPlayer.</li>
            <li> <strong>Web Access</strong>: While GB WhatsApp does not officially support web login, some users mirror
              it using multi-device mode or Android emulators.</li>
          </ul>
          Note: GB WhatsApp is not available on iOS devices due to system restrictions and lack of a compatible build.
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,
      itemsList: [
        {
          img: require('@/assets/GB-WhatsApp-for-andriod.webp'),
          text:'GB WhatsApp Download for Android Phones',
          link: '/download/gb-whatsapp-android/',
        },
        {
          img: require('@/assets/GB-WhatsApp-for-pc.webp'),
          text:'GB WhatsApp Download For PC & Mac',
          link: '/download/gb-whatsapp-pc/',
        },
        {
          img: require('@/assets/GB-WhatsApp-Web.webp'),
          text:'GB WhatsApp Download For Web',
          link: '/download/gb-whatsapp-web/',
        },
      ],
      apk: process.env.VUE_APP_GBLINK || null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav},
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    goJump(link){
      window.location.href = link;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200 && res.data && res.data.apk) {
            this.apk = res.data.apk;
          } else {
            this.apk = this.$global.getGbApkUrl();
          }
        })
        .catch(() => {
          this.apk = this.$global.getGbApkUrl();
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbmodshub.com',
          appName: appname || 'GB_gbmodshub.com',
        })
        .then((res) => {
          if (res.code == 200 && res.data && res.data.apk) {
            if (type == 1) {
              this.apk = res.data.apk;
            } else if (!type && type != 0) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = this.$global.getGbApkUrl();
          }
        })
        .catch(() => {
          this.apk = this.$global.getGbApkUrl();
        });
    },
    goDownload() {
      const url = this.apk || this.$global.getGbApkUrl();
      if (url) {
        this.$global.download(url);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

h2 {
  font-weight: 700;
  font-size: 25px;
  padding: 10px 0;
  border-bottom: 2px dashed #1697BB;
  border-top: 2px dashed #1697BB;
}
</style>